// components/layout/Loading.jsx
//
// MIGRAÇÃO: era src/components/ferramentas/Loading.jsx
// Mova o arquivo original para cá — sem alterar o conteúdo.
//
// Se quiser aproveitar para modernizar, aqui vai uma versão
// simples e alinhada com os tokens da marca:

import React, { useEffect } from "react";
import Style from "../../styles/landing/Loading.module.css";
import Loader from "../../design/components/Loader/Loader";

const Loading = () => {
  // Trava o scroll enquanto a tela de carregamento está montada e devolve ao
  // topo ao sair — evita que um arrasto aqui "vaze" o offset para a próxima
  // tela (a rota inicial usa overflow:auto).
  useEffect(() => {
    const targets = [document.documentElement, document.body].filter(Boolean);
    const prev = targets.map((el) => el.style.overflow);
    targets.forEach((el) => { el.style.overflow = "hidden"; });
    return () => {
      targets.forEach((el, i) => { el.style.overflow = prev[i]; });
      window.scrollTo(0, 0);
    };
  }, []);

  return (
    <div className={Style.container}>
      <div className={Style.logo}>
        {/* Substitua pelo logo SVG da LesVita */}
        {/* <span className={Style.wordmark}>LesVita</span> */}
      </div>
      {/* Um loader só no app inteiro (11-prompt-telas-entrada § 5).
          Fora da tela de verificação ele é só a animação, sem texto. */}
      <Loader tamanho={76} />
    </div>
  );
};

export default Loading;
